import { createAction } from "@reduxjs/toolkit";
import { Empresa } from "../../model/entities/Empresa";

export const setEmpresaAction = createAction<Empresa | null>(
  "EMPRESA_SET/SET_EMPRESA"
);
